@if (displaySchema) {
  <div class="smartphone"
    id="smartphone"
    (drop)="drop($event)"
    (dragover)="allowDrop($event)">
    <div class="content container">
      <sf-form [schema]="displaySchema"
        (onChange)="schemaDataChangeHandler($event.value)" />
      <pre>{{schemaData | json}}</pre>
    </div>
  </div>
}
